/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_InactiveInputs */

const vi_product_inactive = /** @type {(inputs: Product_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngừng bán`)
};

/**

* @param {Product_InactiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_inactive = /** @type {((inputs?: Product_InactiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_InactiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_inactive(inputs)
});